module.exports = {
    expireDays: {
        sessionKey: process.env.COOKIE_SESSION_KEY_EXPIRE_DAYS || 30,
        guestToken: process.env.COOKIE_GUEST_TOKEN_EXPIRE_DAYS || 30,
        language: process.env.COOKIE_USER_LANGUAGE || 30,
    },
};